import React, { useEffect, useCallback } from "react"; // Import useCallback
import { Box, Container, Grid, Typography } from "@mui/material";
import { FaChartLine, FaCheckCircle, FaMoneyBillWave, FaUsers } from "react-icons/fa";

const MarketStatisticsSection = ({ inView, elementsRef, themeColors = {} }) => {
  // Default to empty object
  useEffect(() => {
    if (inView) {
      // GSAP animations (uncomment and debug if needed)
      // gsap.fromTo(
      //   elementsRef.current, // Assuming elementsRef points to the Grid items
      //   { y: 100, opacity: 0 },
      //   { y: 0, opacity: 1, duration: 1, stagger: 0.3 }
      // );
    }
  }, [inView, elementsRef]);

  const stats = [
    { number: "15,000+", label: "Active Users", icon: <FaUsers /> },
    {
      number: "$2.5M+",
      label: "Transactions Monthly",
      icon: <FaMoneyBillWave />,
    },
    { number: "500+", label: "Verified Dealers", icon: <FaCheckCircle /> },
    { number: "99.8%", label: "Success Rate", icon: <FaChartLine /> },
  ];

  // Use useCallback for ref assignments
  const setRef = useCallback(
    (index, el) => {
      if (elementsRef && elementsRef.current) {
        elementsRef.current[index] = el;
      }
    },
    [elementsRef]
  );

  // Define local constants with fallbacks for themeColors properties
  const secondaryColor = themeColors.secondary || "#2D3A27";
  const primaryColor = themeColors.primary || "#F4C542";

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: secondaryColor }}>
      {" "}
      {/* Used local constant */}
      <Container>
        <Typography
          variant="h3"
          align="center"
          fontWeight={700}
          sx={{
            mb: { xs: 6, md: 8 },
            fontSize: { xs: "2rem", md: "3rem" },
            color: "#fff",
          }}
        >
          ScrapTrade by the Numbers
        </Typography>
        <Grid container spacing={4} justifyContent="center" ref={elementsRef}>
          {" "}
          {/* elementsRef is assigned to the Grid container */}
          {stats.map((stat, index) => (
            <Grid
              item
              xs={6}
              md={3}
              key={index}
              ref={(el) => setRef(index, el)}
            >
              {" "}
              {/* Assign ref to individual Grid items */}
              <Box sx={{ textAlign: "center", color: "#fff" }}>
                <Typography variant="h2" sx={{ fontSize: "3rem", mb: 1 }}>
                  {stat.icon}
                </Typography>
                <Typography
                  variant="h4"
                  fontWeight={700}
                  sx={{ color: primaryColor, mb: 1 }} // Used local constant
                >
                  {stat.number}
                </Typography>
                <Typography variant="h6">{stat.label}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MarketStatisticsSection;
